export default __webpack_public_path__ + "static/media/fasting_whatsnext@3x.fcd609fa.jpg";